import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import isToday from "date-fns/isToday";
import format from "date-fns/format";

import * as actions from "../../../../store/actions";
import constants, { NO_DATA_FOUND } from "../../../../constants";
import { useInfiniteScroll } from "../../../../utils/pagination";
import { parseDateToLocal } from "../../../../utils/parseDateTime";
import RequestAppointment from "./RequestAppointment";

const RequestAppointments = ({
  appointments,
  getRequestedAppointments,
  updateAppointmentStatus,
  personalInfo,
  resetAppointmentData,
  removeAppointment,
  updateGuestDoctorRequest,
  getScheduledAppointments,
}) => {
  const [page, setPage] = useState(0);
  const loader = useRef(null);
  const [playRing, setPlayRing] = useState(false);
  useInfiniteScroll(loader, () => setPage(page => page + 1));

  useEffect(() => {
    resetAppointmentData();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (page <= appointments?.totalPages && page > 0) {
      getRequestedAppointments(page);
      if (localStorage.getItem("playRing") === "false") {
        localStorage.setItem("playRing", true);
      }
    }
    // eslint-disable-next-line
  }, [page,getRequestedAppointments]);

  const requestedAppointments = appointments?.requests;
  const selectedScheduleDate = format(
    appointments?.selectedScheduleDate || new Date(),
    "yyyy-MM-dd"
  );
  
  return (
    <>
      {Object.keys(requestedAppointments).length === 0 && (
        <p className="content-center m-auto not-found-image">
          <img
            src={NO_DATA_FOUND}
            width={366}
            height={300}
            alt="requests-not-found"
          />
        </p>
      )}
      {Object.keys(requestedAppointments)
        ?.sort()
        .map(obj => (
          <>
            {requestedAppointments[obj]?.length > 0 && (
              <div className="mt-3" id="divRoot">
                <span>
                  {isToday(parseDateToLocal(obj))
                    ? "Today"
                    : format(parseDateToLocal(obj), "MMM dd")}
                </span>
                <span
                  className="d-inline-block border-bottom ml-2 col-md-11"
                  style={{
                    verticalAlign: "middle",
                  }}
                ></span>
                <div className="row p-3">
                  {requestedAppointments[obj].map(reqAppointment => (
                    <>
                      <RequestAppointment
                        appointmentData={reqAppointment}
                        onMyAppointments={() => {
                          removeAppointment(reqAppointment);
                          getScheduledAppointments(1, selectedScheduleDate);
                        }}
                        onUpdate={updateAppointmentStatus}
                        personalInfo={personalInfo}
                        onGuestUpdate={updateGuestDoctorRequest}
                      />
                    </>
                  ))}
                </div>
              </div>
            )}
          </>
        ))}
      <div ref={loader}></div>
    </>
  );
};

const mapStoreToProps = ({ onboarding, dashboard }) => ({
  personalInfo: onboarding.personalInfo,
  appointments: dashboard.appointments,
});

const mapDispatchToProps = dispatch => ({
  getScheduledAppointments: (page, date) =>
    dispatch(
      actions.getAppointments(
        [constants.APPOINTMENT_STATUS.accepted,constants.APPOINTMENT_STATUS.cancelled,constants.APPOINTMENT_STATUS.completed,
        constants.APPOINTMENT_STATUS.noshow],
        page,
        date
      )
    ),
  getRequestedAppointments: page =>
    dispatch(
      actions.getAppointments([constants.APPOINTMENT_STATUS.requested],page)
    ),
  updateAppointmentStatus: (id, status, cb) =>
    dispatch(actions.updateAppointmentStatus(id, status, cb)),
  resetAppointmentData: () => dispatch(actions.resetAppointmentData()),
  removeAppointment: updateData =>
    dispatch(actions.removeAppointment(updateData)),
  updateGuestDoctorRequest: (id, status, cb) =>
    dispatch(actions.updateGuestDoctorRequest(id, status, cb)),
});

export default connect(
  mapStoreToProps,
  mapDispatchToProps
)(RequestAppointments);
